import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=d0aa3af2&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0aa3af2')) {
      api.createRecord('d0aa3af2', component.options)
    } else {
      api.reload('d0aa3af2', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=d0aa3af2&", function () {
      api.rerender('d0aa3af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4d195u9WS0g8j/JS/comp/costHelpSpa.vue"
export default component.exports